'use strict';
import template from './templates/submenu.tpl.html';
const defaultPosition = 'left';

function submenu() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    require: ['^akamMenuButton', 'akamSubmenu'],
    scope: {},
    template,
    bindToController: {
      text: '@',
      icon: '@?',
      size: '@',
      position: '@',
      isDisabled: '=?'
    },
    controller: () => ({
      initialize(akamMenuButtonController) {
        this.size = this.size || akamMenuButtonController.size;
        this.position = this.position || akamMenuButtonController.position || defaultPosition;
        this.positionClass = `nested-menu-${this.position}`;
      }
    }),
    controllerAs: 'submenu',
    link(scope, elem, attrs, [menuBtnCtrl, submenuCtrl]) {
      submenuCtrl.initialize(menuBtnCtrl);
    }
  };
}

export default submenu;